export default __webpack_public_path__ + "static/media/logo.ca68768e.png";